module.exports = __webpack_public_path__ + "img/pic-bmou.aa6dcbc3.png";